'use client';

import type { ProductsData, ProductsPayload } from '@/app/api/search/products/createProductsData';
import { usePageWrapperData } from '@/app/common/pageWrapperProvider';
import useSWR from 'swr';
import { API_NAME } from '../../search/common/apiTypes';
import { getSearchParamsClient } from '../../search/common/getSearchParams';
import { BASE_PATH } from '../../search/utils/path';
import { fetchWithTracingAndLogging } from '../common/fetchWithTracing';
import { getLoggingInfo } from '../lib/loggingInfo';
import { useInitialParams } from '../InitialParamsProvider';
import { useCreateAsyncPricing } from '../PricingProvider';

export function useFetchSearchProductsForDetailsMap() {
  const {
    searchParams: searchParamsServer,
    searchInfoData,
    commonData,
    localization,
    curiosityParams,
  } = usePageWrapperData();
  const searchParams = getSearchParamsClient(searchParamsServer);
  const { pageType } = useInitialParams();
  const { data: asyncPricing } = useCreateAsyncPricing();

  const productsPayload: ProductsPayload = {
    searchParams,
    isSearchFromServer: false,
    commonData,
    localization,
    curiosityParams,
  };
  const key: string | undefined = asyncPricing?.pricingId ? `map-products-${asyncPricing.pricingId}` : undefined;
  return useSWR(
    key,
    async () =>
      fetchWithTracingAndLogging<ProductsData>(
        `${BASE_PATH}/api/${API_NAME.PRODUCTS}`,
        {
          method: 'POST',
          headers: {
            'content-type': 'application/json',
          },
          body: JSON.stringify({ ...productsPayload }),
        },
        getLoggingInfo(pageType, 'memsearch-search-products', 'DetailsMap'),
        searchInfoData.searchTraceParent,
        commonData
      ),
    {
      revalidateIfStale: false,
      revalidateOnFocus: false,
      revalidateOnReconnect: false,
      shouldRetryOnError: false,
      dedupingInterval: 1000 * 60 * 30,
    }
  );
}
